'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$33() {
  this.bhg = null;
  this.bhe = null;
  this.bhf = false;
  this.bhc = null;
  this.bhd = false;
  this.bhh = false;
  this.bhi = false;
  this.bhg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$33 as $c_Lpresto_PrestoRouter$$anon$33 };
$p = $c_Lpresto_PrestoRouter$$anon$33.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$33;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$33() {
}
export { $h_Lpresto_PrestoRouter$$anon$33 as $h_Lpresto_PrestoRouter$$anon$33 };
$h_Lpresto_PrestoRouter$$anon$33.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhg;
});
$p.t = (function() {
  if ((!this.bhf)) {
    this.bhe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhf = true;
  }
  return this.bhe;
});
$p.ae = (function() {
  if ((!this.bhd)) {
    this.bhc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhd = true;
  }
  return this.bhc;
});
$p.w = (function() {
  if ((!this.bhi)) {
    this.bhh = false;
    this.bhi = true;
  }
  return this.bhh;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$33 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$33, "presto.PrestoRouter$$anon$33", ({
  NZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$33 as $d_Lpresto_PrestoRouter$$anon$33 };
//# sourceMappingURL=presto.-Presto-Router$$anon$33.js.map
